import icLinkExternal from 'assets/images/ic-link-external.svg'
import { Button, Drawer, Spinner } from 'avo-ui'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import { TABLE_VOTER } from 'configs/award/configTableVoter'

export const Voter = ({
    data,
    dataPreview,
    query,
    onChangeQuery,
    isLoading,
    isLoadingPreview,
    onActionRow,
    setModal,
    modal,
}) => {
    return (
        <div className={'flex flex-col'}>
            <div className={'flex gap-x-3'}>
                <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    onClick={() => setModal({ ...modal, export: true })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_VOTER.name}
                columns={TABLE_VOTER.column}
                data={data?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={data?.total_page}
                totalResult={data?.total_result}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />

            <Drawer show={modal?.preview} onHide={() => setModal({ ...modal, preview: false })}>
                <div className='px-6 space-y-5'>
                    <div className='font-medium text-lg mt-6'>{'Detail Vote'}</div>

                    {isLoadingPreview ? (
                        <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
                    ) : (
                        <>
                            <div className='flex'>
                                <div className='w-[120px] text-neutral-70 pr-2'>Nama</div>
                                <div className='flex-1 font-medium text-neutral-80'>{dataPreview?.name || '-'}</div>
                            </div>
                            <div className='flex'>
                                <div className='w-[120px] text-neutral-70 pr-2'>Email</div>
                                <div className='flex-1 font-medium text-neutral-80'>{dataPreview?.email || '-'}</div>
                            </div>
                            <div className='font-medium'>{'List Votes'}</div>
                            {dataPreview?.votes?.map((item, index) => (
                                <div key={index} className='flex'>
                                    <div className='w-[120px] text-neutral-70 pr-2'>{item?.voted_nomination}</div>
                                    <div className='flex-1 font-medium text-neutral-80'>
                                        {item?.voted_nominee || '-'}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </Drawer>
        </div>
    )
}
